import type { ScrollAnchorStrategy } from 'src/modules/shared/types/scroll/scroll-anchor.types';

/**
 * Selects stable Message content across regrouping and ordinary timeline cards.
 * Individual Message anchors take precedence over their replaceable group wrapper.
 */
export const timelineScrollAnchorStrategy: ScrollAnchorStrategy = {
  getElements: (container) =>
    Array.from(
      container.querySelectorAll<HTMLElement>(
        '[data-timeline-anchor], [data-timeline-item]'
      )
    ).filter(
      (element) =>
        !element.hasAttribute('data-timeline-item') ||
        !element.querySelector('[data-timeline-anchor]')
    ),
  getKey: (element) => element.dataset.timelineAnchor,
};
